import { useMutation } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

export const useSendFeedback = () =>
  useMutation({
    mutationFn: async (application: { payment_feedback_reasons_id?: number; custom_feedback?: string, platform?: string; }) => {
      const { data } = await $apiV2.post('/payment-feedback-reason/create', application);

      return data;
    }
  });
